import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    snackbar: {
      message: '',
      type: ''
    },
    currentUser: {},
    binanceKeys: {},
    assets: [],
    totalHoldings: []
  },
  getters: {
    getIsLoading(state) {
      return state.isLoading
    },
    getSnackbar(state) {
      return state.snackbar
    },
    displaySnackbar(state) {
      return state.snackbar.message && state.snackbar.type
    },
    getCurrentUser(state) {
      return state.currentUser
    },
    isBinanceKeyConnected(state) {
      return state.binanceKeys && state.binanceKeys.status
    },
    getTradingBinanceStatus(state) {
      return state.binanceKeys && state.binanceKeys.trading_status
    },
    getAssets(state) {
      return state.assets
    },
    getTotalHoldings(state) {
      return state.totalHoldings
    }
  },
  mutations: {
    setIsLoading(state, payload) {
      state.isLoading = payload
    },
    setSnackbar(state, payload) {
      state.snackbar = payload
    },
    hideSnackbar(state) {
      state.snackbar = {}
    },
    setBinanceKeys(state, payload) {
      state.binanceKeys = payload
    },
    setCurrentUser(state, payload) {
      state.currentUser = payload
    },
    setAssets(state, payload) {
      state.assets = payload
    },
    setTotalHoldings(state, payload) {
      state.totalHoldings = payload
    }
  },
  actions: {
    setIsLoading({ commit }, payload) {
      commit('setIsLoading', payload)
    },
    setSnackbar({ commit }, payload) {
      commit('setSnackbar', payload)
    },
    setSnackbarError({ commit }, payload) {
      commit('setSnackbar', {
        type: 'error',
        message: payload
      })
    },
    setSnackbarSuccess({ commit }, payload) {
      commit('setSnackbar', {
        type: 'success',
        message: payload
      })
    },
    hideSnackbar({ commit }) {
      commit('hideSnackbar')
    },
    setBinanceKeys({ commit, state }, payload) {
      commit('setBinanceKeys', {
        ...state.binanceKeys,
        ...payload
      })
    },
    setCurrentUser({ commit, state }, payload) {
      commit('setCurrentUser', {
        ...state.currentUser,
        ...payload
      })
    },
    setAssets({ commit }, payload) {
      commit('setAssets', payload)
    },
    setTotalHoldings({ commit }, payload) {
      commit('setTotalHoldings', Object.entries(payload || {})
          .map(([key, value]) => ({ coin: key, value })))
    }
  }
})
